<ng-container *transloco="let t">
  <div class="row">
    <div class="col-12 col-xxl-6">
      <div class="pb-20">
        <app-grid-item-title [title]="t('app.landing.upcoming.events')" />
      </div>
      @if(raceUpcomingEvents.length ?? 0 > 0){
      <div (scroll)="onScroll($event)" [ngClass]="{'scrollable-table': !isAdmin}">
        @for (race of raceUpcomingEvents;track race) {
        <app-event-list-item [countries]="countries" [race]="race" [languages]="languages" />
        }
      </div>
      }@else {
      <app-empty-state />
      }
    </div>
    <div class="col-12 col-xxl-6">
      <div class="pb-20">
        <app-grid-item-title [title]="t('app.user.profile.my.wish.list')"
          [spaceBetweenTitleAndTrailing]="true">
          <div class="pe-10">
            <img src="assets/icons/red-outlined-heart.svg" alt="Heart" width="30" />
          </div>
        </app-grid-item-title>
      </div>
      <ng-container *transloco="let t">
        @if(favoriteItems.length ?? 0 > 0){
        <div class="row row-cols-1 row-cols-sm-2">
          <div (scroll)="onScroll($event)" [ngClass]="{'scrollable-table': !isAdmin}">
            @for(item of favoriteItems; let last = $last;track item){
            <div class="col" [class.mb-4]="!last">
              <app-event-grid-item-with-image-small (click)="goToEventDetailsPage(item)" [eventItem]="item"
                [countries]="countries" [isOnWishList]="true" [languages]="languages" />
            </div>
            }
          </div>
        </div>
        }@else {
        <app-empty-state />
        }

      </ng-container>
    </div>
  </div>
  <div class="row">
    <div class="col-12 pb-38-34">
      <div class="pb-20">
        <app-grid-item-title [title]="t('app.user.profile.my.results')" />
      </div>
      <div class="pb-20">
        @if(races.length ?? 0 > 0){
        <div>
          @for (race of races;track $index) {
          <div (scroll)="onScroll($event)" [ngClass]="{'scrollable-table': !isAdmin}">
            <app-results-table [results]="raceResultsMap.get(race) ?? []" [languages]="languages"
              [filteringEnabled]="false" [showEmptyState]="false" [showBorderBottom]="($index !== races.length - 1)">
              <div class="pt-16 mb-16">
                <app-races-header [race]="race" [showExportButton]="true"></app-races-header>
              </div>
            </app-results-table>
          </div>
          }
        </div>
        }@else {
        <app-empty-state />
        }
      </div>
    </div>
    <div class="col-12">
      <div class="pb-20">
        <app-grid-item-title [title]="t('app.common.mailbox')" />
      </div>
      <div class="pb-10">
        @if(unreadMessages && unreadMessages.length>0){
        <div class="row">
          <app-mailbox-list-item [unreadMessages]="unreadMessages" [isUnread]="true" [users]="users" />
        </div>
        }@else {
        <app-empty-state />
        }
      </div>
    </div>
  </div>

</ng-container>
